import { createTheme } from '@mui/material/styles';

/** Nested theme for Darbų planai only — accent matches handoff */
export const workPlansNestedTheme = createTheme({
  palette: {
    primary: {
      main: '#2563EB',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
